export const useIpRestrictStore = defineStore('ipRestrict', () => {
  const isIpRestricted = ref(false)

  const setIpRestricted = (value: boolean) => {
    isIpRestricted.value = value
  }

  return {
    isIpRestricted,
    setIpRestricted,
  }
})
